module.exports = __webpack_public_path__ + "static/media/qrcode.f65fe741.png";